import Browser from '@ww-digital/web-palette-react/dist/components/Utility/Browser';

export const isMatchedDate = (
  startDate: string,
  endDate: string,
  timezone: string,
  dateStringFormat: string,
) => {
  let currentDate = new Date().toLocaleString(dateStringFormat, {
    timeZone: timezone,
  });
  // Use the preview date if it is set.
  if (Browser.isBrowser()) {
    const urlParams = new URLSearchParams(window.location.search);
    const xspreviewtests = urlParams.get('xspreviewtests');
    const xspreviewdate = urlParams.get('xspreviewdate');
    if (xspreviewtests && xspreviewdate) {
      // xspreviewdate is always in format "YYYY-MM-DD" (e.g., "2025-8-30" or "2025-08-30")
      // Parse components and create a date representing midnight in the config timezone
      const dateParts = xspreviewdate.split('-');

      if (dateParts.length === 3) {
        const year = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10);
        const day = parseInt(dateParts[2], 10);

        // Create a date string that represents midnight in the config timezone
        // Simple approach: construct a date string that will be interpreted correctly
        const previewDateString = `${month}/${day}/${year}, 12:00:00 AM`;

        // Use this date string directly for comparison since it matches the format
        // of the experiment startDate/endDate strings
        currentDate = previewDateString;
      }
    }
  }
  return (
    Date.parse(currentDate) >= Date.parse(startDate) &&
    Date.parse(currentDate) <= Date.parse(endDate)
  );
};
